/*
|--------------------------------------------------------------------------
| Utilities: Fetch: HTML
|--------------------------------------------------------------------------
*/

/**
 * Fetch HTML will listen for a click event and use the data attributes on
 * the item to retrieve html content from a url and put it into a dom container.
 * @memberof utilities.fetch
 * @namespace utilities.fetch.html
 * @inner
 */
__gh__webApp.utilities.fetch.html = {

	/**
	 * Initialize
	 *
	 * @memberof utilities.fetch.html
	 * @method init
	 */
	"init": function() {
		this.bindEvents();
		this.loadAllHTML();
	},

	/**
	 * Get the html and insert it into a DOM
	 *
	 * @memberof utilities.fetch.html
	 * @method get
	 * @param {object} options
	 * @param {string} options.dom - dom selector for the container to insert the html
	 * @param {string} options.url - url to get the html from
	 * @example
	 * __gh__webApp.utilities.fetch.html.get({"dom":"#container","url":"http://newspaper.com/html/content/url"});
	 */
	"get" : function(options) {
		var commonJS	= __gh__webApp.common,
			dom 		= (options.dom) 		? options.dom 		: null,
	    	url 		= (options.url) 		? options.url 		: null,
	    	callbacks 	= (options.callbacks)	? options.callbacks	: null;

		if(!url){
			__gh__webApp.utilities.errorLog({controller:"__gh__webApp.utilities.fetch.html.get",message:"Missing url."});
			return;
		}
		if(!dom){
			__gh__webApp.utilities.errorLog({controller:"__gh__webApp.utilities.fetch.html.get",message:"Missing dom."});
			return;
		}

		if(url.split(':')[0] == 'data') {
			$(dom).html(url);
			if (callbacks){
				__gh__webApp.common.callArrayOfFunctions(callbacks);
			}
			return;
		}

		url = commonJS.noCacheURL(url);

	    $.ajax({
	        'async': true,
	        'global': false,
	        'url': url,
	        'dataType': "html",
	        'success': function (html) {
	           $(dom).html(html);
	           	//Run callback function
				if (callbacks){
					__gh__webApp.common.callArrayOfFunctions(callbacks);
				}
	        }
	    });
	},


	/**
	 * Gets the fetch html object from the dom
	 * Will use the dom with the data attributes if no "dom" is given
	 *
	 * @memberof utilities.fetch.html
	 * @method getFetchHTMLObject
	 */
	 "getFetchHTMLObject": function($dom){
		var fetchHTMLObject = $dom.data('gh-fetch-html-object');
			
		fetchHTMLObject = (fetchHTMLObject) ? fetchHTMLObject : {
			'dom'		: $dom.data('gh-fetch-html-dom'),
			'url'		: $dom.data('gh-fetch-html-url'),
			"callbacks"	: $dom.data("gh-fetch-html-callbacks")
		};

		if (!fetchHTMLObject.dom){
			fetchHTMLObject.dom = $dom[0];
		}

		return fetchHTMLObject;
	},
	
	
	/**
	 * Loads html for all items on a page with the correct data attributes
	 *
	 * @memberof utilities.fetch.html
	 * @method loadAllHTML
	 * @param {object} options
	 * @param {string} options.dom - dom selector for the container to insert the html
	 * @param {string} options.url - url to get the html from
	 * @example
	 * &lt;div id="example" data-gh-fetch-html-dom="#example" data-gh-fetch-html-url="http://example.com/html"&gt;&lt;/div&gt;
	 */
	 "loadAllHTML": function() {
		var thisObject  = __gh__webApp.utilities.fetch.html,
			fetchHTML 	= thisObject.get;
		//Auto load html content
		$("[data-gh-fetch-html-loaded=false]").each(function(){
			var $this  			= $(this),
				fetchHTMLObject = thisObject.getFetchHTMLObject($this);

			fetchHTML(fetchHTMLObject);

			//Only load html once.
			if(!$this.data("gh-fetch-html-loaded")){
				$this.attr("data-gh-fetch-html-loaded",true);
			}

	  	});
	},


	/**
	 * Load a lazy html
	 * @memberof utilities.fetch.html
	 * @method loadLazyHTML
	 */
	"loadLazyHTML": function(){
		var thisObject 	= __gh__webApp.utilities.fetch.html,
			fetchHTML 	= thisObject.get,
			$lazyHTML 	= $("[data-gh-fetch-lazy-html-loaded=false]").first(),
			fetchHTMLObject;

		//Check to see if is on screen
		if ($lazyHTML.length && $lazyHTML.isOnScreen(500)){

	    	fetchHTMLObject = thisObject.getFetchHTMLObject($lazyHTML);
	    	
	    	fetchHTML(fetchHTMLObject);
	    	
			$lazyHTML.attr("data-gh-fetch-lazy-html-loaded",true);
	    }
	},


	/**
	 * Bind the UI events
	 *
	 * @memberof utilities.fetch.html
	 * @method bindEvents
	 * @example <caption>Fetch HTML on click</caption>
	 * 	&lt;div id="container"&gt;&lt;/div&gt;&lt;a href="#" data-gh-fetch-html-url="http://redesign.gatehousemedia.com/jason/targetHTML.html" data-gh-fetch-html-dom="#container"&gt;Test&lt;/a&gt;
	 *
	 */
	"bindEvents": function() {
		var thisObject  = __gh__webApp.utilities.fetch.html,
			fetchHTML 	= thisObject.get;
		
		//Load html content on click
	    $(document).on("click", "a[data-gh-fetch-html-url]", function(event){
		    event.preventDefault();
			var $this = $(this),
				fetchHTMLObject = thisObject.getFetchHTMLObject($this);
			fetchHTML(fetchHTMLObject);
		});

		$(document).on("scroll.gh-fetch-lazy-html",this.loadLazyHTML);
  	},
};
